<script setup lang="ts">
import { RouterView } from 'vue-router';
import BottomNav from '@/components/BottomNav.vue';
import CelebrationOverlay from '@/components/CelebrationOverlay.vue';
</script>

<template>
  <div
    class="min-h-screen flex justify-center"
    style="background-color: #070709;"
  >
    <div class="w-full max-w-[480px] min-h-screen flex flex-col relative">
      <!-- Scrollable body -->
      <main class="flex-1 overflow-y-auto pb-24">
        <RouterView />
        <!-- Powered by footer -->
        <div class="text-center py-4">
          <p
            class="text-[12px] tracking-wider"
            style="color: var(--dim, #55556A); font-family: 'DM Sans', system-ui, sans-serif;"
          >
            Powered by Ice Master
          </p>
        </div>
      </main>

      <!-- Bottom navigation -->
      <BottomNav />
    </div>

    <!-- Global celebration overlay -->
    <CelebrationOverlay />
  </div>
</template>
